import { render, staticRenderFns } from "./specView.vue?vue&type=template&id=267f82ac&"
import script from "./specView.vue?vue&type=script&lang=js&"
export * from "./specView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports